<template>
  <div
    class="card-research"
    :style="{'background-image': backgroundImage}"
  >
    <div
      class="card mb-3 card-container"
      :class="cardClass"
      @click="emitClick"
    >
      <div class="bg-light">
        <div
          class="row p-2"
        >
          <div class="col-6">
            <div v-if="startDate">
              {{ toPrettyMonthDate(startDate) }}
            </div>
          </div>
          <div class="col-6 text-right">
            <v-research-status-badge
              :status="status"
            />
          </div>
        </div>
      </div>
      <div class="card-body">
        <h5
          class="text-truncate"
          :class="titleClass"
        >
          {{ title }}
        </h5>

        <v-research-info
          :average="commercial ? commercial.average_rating: null"
          :number-of-reviews="sessionsCount"
          :group-size="groupSize"
          :start-date="startDate"
          :end-date="endDate"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { toPrettyDate, toPrettyMonthDate } from '@/common/utils/formatting';
import { RESEARCH_ICON_CLASSES, RESEARCH_STATUS_CLASSES } from '@/common/utils/constants';
import ResearchStatusBadge from '@/common/components/research/ResearchStatusBadge.vue';
import ResearchInfo from '@/common/components/research/ResearchInfo.vue';
import { CLICKABLE_STATUSES } from '@/organisation/services/researches';

export default {
  name: 'OrganisationResearchCard',
  components: {
    'v-research-info': ResearchInfo,
    'v-research-status-badge': ResearchStatusBadge,
  },
  props: {
    uuid: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
    },
    startDate: {
      type: Date,
      required: false,
    },
    endDate: {
      type: Date,
      required: false,
    },
    groupSize: {
      type: Number,
      required: true,
    },
    sessionsCount: {
      type: Number,
      required: true,
    },
    commercial: {
      type: Object,
      required: false,
    },
    status: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      RESEARCH_ICON_CLASSES,
      RESEARCH_STATUS_CLASSES,
    };
  },
  methods: {
    toPrettyDate,
    toPrettyMonthDate,
    emitClick() {
      if (CLICKABLE_STATUSES.includes(this.status)) {
        this.$emit('click', this.uuid, this.status);
      }
    },
  },
  computed: {
    cardClass() {
      return {
        'card-clickable': CLICKABLE_STATUSES.includes(this.status),
      };
    },
    titleClass() {
      return {
        'text-muted': !CLICKABLE_STATUSES.includes(this.status),
      };
    },
    backgroundImage() {
      if (!this.commercial) {
        // eslint-disable-next-line global-require
        return `url('${require('@/common/assets/img/research.png')}')`;
      }

      if (this.commercial.youtube_image_url) {
        return `url('${this.commercial.youtube_image_url}')`;
      }
      if (this.commercial.commercial_type === 'radio') {
        // eslint-disable-next-line global-require
        return `url('${require('@/common/assets/img/radio.jpg')}')`;
      }
      if (this.commercial.commercial_type === 'ooh') {
        // eslint-disable-next-line global-require
        return `url('${require('@/common/assets/img/billboard.jpg')}')`;
      }
      // eslint-disable-next-line global-require
      return `url('${require('@/common/assets/img/research.png')}')`;
    },
    labels() {
      if (this.sessionsCount >= this.groupSize) {
        return [this.$t('word.reviewed')];
      }
      return [this.$t('word.reviewed'), this.$t('phrase.reviews_to_go')];
    },
  },
};
</script>

<style scoped>
.bg-progress-light {
  background-color: #ced0d3 !important;
}

.progress-text {
  padding-top: 7px;
  height: 15px;
}

.progress-text-finished {
  padding-top: 2px;
  height: 15px;
}

.progress {
  height: 15px !important;
  font-size: 11px;
}

.card-research {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  box-sizing: border-box;
  position: relative;
}

.card-container {
  background: rgba(255, 255, 255, 0.9);
}

.card-clickable {
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}

.card-clickable:hover {
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  background: rgba(0, 0, 0, 0.50);
  color: #fff !important;
}

.research-count span {
  font-size: 40px;
}
</style>
